import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {loadStripe} from '@stripe/stripe-js/pure';
import {AngularFireFunctions} from '@angular/fire/functions';

// const stripePromise = loadStripe('pk_live_Alk04fb7KAp2n3KW359tLAuI');
const stripePromise = loadStripe('pk_test_Ti7jlUMaa85z1sl5UjqMga7T00jw1OIFaO');

@Component({
  selector: 'app-no-access-modal',
  templateUrl: './no-access-modal.component.html',
  styleUrls: ['./no-access-modal.component.scss']
})
export class NoAccessModalComponent implements OnInit, AfterViewInit {
  stripeFunction: any;
  loading = false;
  // @ViewChild("cardElement", {static: false}) cardElement: ElementRef;
  @Output()
  clickedPurchase: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  retryPurchase: EventEmitter<any> = new EventEmitter<any>();
  @Input()
  error = false;
  @Input()
  errorMessage = "";
  @Input()
  channelStream = true;
  constructor(public firebaseAuth: AngularFireAuth,  private fns: AngularFireFunctions) {
    // this.stripeFunction = fns.httpsCallable('stripe-createStripeSession');
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.createStripePaymentIntent().then((res) => {
    //     console.log("HI")
    //   });
    // }, 1500);
  }

  purchaseVideo() {
    this.loading = true;
    this.clickedPurchase.emit();
  }

  // async createStripePaymentIntent() {
  //   const stripe = await stripePromise;
  //   const elements = stripe.elements();
  //   var style = {
  //     base: {
  //       color: "#32325d",
  //     }
  //   };
  //
  //   var card = elements.create("card", { style: style });
  //   card.mount(this.cardElement.nativeElement);
  // }

}
